import { isCliImmediateShutdownRequested } from '../runtime/cli-process-interrupt.js';
import { yieldToEventLoop } from '../runtime/yield-to-event-loop.js';
import { CliSqliteInterrupted } from './sqlite-errors.js';

export const SYNC_RETRY_MAX = 40;
export const ASYNC_RETRY_MAX = 60;
export const ASYNC_PROBE_RETRY_MAX = 2;

export const ASYNC_BASE_DELAY_MS = 20;

/**
 * Brief synchronous wait for SQLite lock retries inside `withSync`.
 * Uses short chunks so SIGINT/shutdown checks run frequently; prefer `withAsync` on background paths.
 */
export function syncSleepMs(ms: number): void {
  if (ms <= 0) return;
  const deadline = Date.now() + ms;
  while (Date.now() < deadline) {
    if (isCliImmediateShutdownRequested()) throw new CliSqliteInterrupted();
    const chunk = Math.min(10, deadline - Date.now());
    if (chunk <= 0) break;
    try {
      const sab = new SharedArrayBuffer(4);
      const ia = new Int32Array(sab);
      Atomics.wait(ia, 0, 0, chunk);
    } catch {
      const end = Date.now() + chunk;
      while (Date.now() < end) {
        if (isCliImmediateShutdownRequested()) throw new CliSqliteInterrupted();
      }
    }
  }
}

export async function asyncDelayMsInterruptible(ms: number): Promise<void> {
  const end = Date.now() + ms;
  while (Date.now() < end) {
    if (isCliImmediateShutdownRequested()) throw new CliSqliteInterrupted();
    const chunk = Math.min(50, end - Date.now());
    if (chunk <= 0) break;
    await new Promise<void>((r) => setTimeout(r, chunk));
    await yieldToEventLoop();
  }
}
